/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import { Module } from 'vuex'

export interface Changelog {
  username: string,
  token: string,
}

const changelogModule: Module<any, any> = {

  state: {
    logs: [],
    posts: [],
    totalRows: 0
  },

  actions: {
    async GetChangelogs ({ commit }) {
      const response = {
        logs: [{
          id: 1,
          ipAddress: '***.***.***.123',
          parameter: 'Post Copy',
          previousValue: 'Pending Approval',
          changed: 1,
          changeType: 'Approved',
          changeDate: '2021-09-12',
          member: {
            name: 'Tim Bell',
            email: 'timbell@example.com',
            profile: '/images/profile-img/img-01.jpg'
          }
        }, {
          id: 2,
          ipAddress: '***.***.***.456',
          parameter: 'n/a',
          previousValue: 'Draft',
          changed: 'Account Settings',
          changeType: 'Deleted',
          changeDate: '2021-10-03',
          member: {
            name: 'Darlene Robertson',
            email: 'darlene@example.com',
            profile: '/images/profile-img/img-02.jpg'
          }
        }, {
          id: 3,
          ipAddress: '***.***.***.824',
          parameter: 'n/a',
          previousValue: 'Pending Approval',
          changed: 1,
          changeType: 'Approved',
          changeDate: '2021-08-08',
          member: {
            name: 'Kathryn Murphy',
            email: 'murphy@example.com',
            profile: '/images/profile-img/img-03.jpg'
          }
        }],

        posts: [{
          id: 1,
          content: 'The quick brown fox jumps',
          icon: '/images/profile-img/img-06.jpg'
        }],

        totalRows: 3
      }
      // cSpell:enable

      commit('setPosts', response.posts)
      commit('setChangelogs', response.logs)
      commit('setTotalRows', response.totalRows)

      return response
    }
  },

  mutations: {
    setPosts (state: any, posts) {
      state.posts = posts
    },
    setChangelogs (state: any, logs) {
      state.logs = logs
    },
    setTotalRows (state: any, rows: number) {
      state.totalRows = rows
    }
  }
}

export default changelogModule
/* jscpd:ignore-end */
